import React from "react";
import { SVG, IconProps } from "../SVG";
export const PaymentPlan = ({ color = "currentColor", strokeWidth = 3.2, ...props }: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 49" {...props}>
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M2 40.82V32.1m0 0h9.031m-9.03 0 9.28 8.72a18 18 0 0 0 29.7-6.72m5.018-24.6v9.8H35.97M45 17.296l-9.28-8.72a18 18 0 0 0-29.7 6.72"
        />
        <g clipPath="url(#payment_plan_svg__a)">
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M24 12.4v24.2m5.5-19.8h-8.25a3.85 3.85 0 1 0 0 7.7h5.5a3.85 3.85 0 0 1 0 7.7H17.4"
            />
        </g>
        <defs>
            <clipPath id="payment_plan_svg__a">
                <path fill="#fff" d="M10.8 11.3h26.4v26.4H10.8z" />
            </clipPath>
        </defs>
    </SVG>
);
PaymentPlan.displayName = "PaymentPlan";
